import React, { useState, useCallback, useContext, useEffect } from 'react'//,{useState,useCallback}
import styles from './ContactSettings.module.css'
import { Button } from 'react-bootstrap'
import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'
import DropDownV2 from '../../../UI/DropDownV2/DropDownV2';
import { useTranslation } from "react-i18next";
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import ContactClassification from './ContactClassification';
import ActivityManagement from './ActivityManagement';
// import { getDropDownList, updateDropDownItem, deleteDropDownItem } from '../../../../axios/requests/dropDownReq'
// import useInput from '../../../../hooks/use-input'
// import {useTranslation} from "react-i18next";

const getErrorMsg = (settingName, value) => {
    switch (settingName) {
        case 'closeInquiriesAfterHours':
            if (!Number.isInteger(Number(value)) || value < 0) return 'auto close inquiry must be integer'
            break;
        default:
            return undefined
    }
}


const ContactSettings = (props) => {
    const [t] = useTranslation('common')
    const alertCtx = useContext(AlertContext)

    const { setSettings, setSaveAndRestartBtnActiveState, generalSettings } = props

    const setSettingsMiddleware = useCallback((settingType, settingName, value) => {
        const errorMsg = getErrorMsg(settingName, value)
        if (errorMsg) return alertCtx.showAlert(t('fail'), t(errorMsg), 'sm')

        setSettings(settingType, settingName, value)
        setSaveAndRestartBtnActiveState(true)
    }, [setSettings, setSaveAndRestartBtnActiveState, alertCtx, t])


    const booleanSelectionTypeOpt = [true, false]

    return (
        <section className={styles.channelSettingsSection}>
            <div >
                <h2 className={styles.settingsTitle}>{t('Contacts') + ' :'}</h2>
                <SettingsDropDown nowSelected={generalSettings.enableFetchContactFromCrm} setSettings={setSettingsMiddleware} settingType={'general'} label={'Enable fetch contacts from chats and calls'} settingName={'onSetEnableFetchContactFromCrm'} items={booleanSelectionTypeOpt} />

                <h2 className={styles.settingsTitle} style={{textDecoration:'none'}}>{t('activity management') + ' :'}</h2>
                <ActivityManagement />
                <ContactClassification />


            </div>
        </section >
    )
}

export default ContactSettings
